import { render, staticRenderFns } from "./DishTagsList.vue?vue&type=template&id=282d23b8"
import script from "./DishTagsList.vue?vue&type=script&lang=js"
export * from "./DishTagsList.vue?vue&type=script&lang=js"
import style0 from "./DishTagsList.vue?vue&type=style&index=0&id=282d23b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports